module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-DealerDraftMazda-Playful5.efecd6b2.jpeg";